var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.251 4.167 8.728 1.69h1.808l2.476 2.477v1.808L10.536 8.45H8.728l-.831-.83-1.68 1.68 1.788 1.788-.707.707-1.789-1.788-1.521 1.521v.551l1.522 1.523-.707.707-1.815-1.816v-1.38L7.19 6.914l-.939-.938V4.167Zm1 .414v.98l1.89 1.89h.98l1.891-1.89v-.98l-1.89-1.89h-.98l-1.89 1.89Z",
    fill: "currentColor"
  })));
};
export default SvgKey;